import { useDispatch, useSelector } from "react-redux";
import SwipeableViews from "react-swipeable-views";
import { useTheme } from "@mui/material/styles";

import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { actionLayerTabChanged } from "./LayerRedux";
import { layerComponents } from "./LayerData";
import GraphicsTabPanel from "./TabPanelGraphics";
import LabelTabPanel from "./TabPanelLabel";
import ColorTabPanel from "./TabPanelColor";

const tabHeading_ = (theme) => ({
  overflow: "auto",
});

const tabPanel_ = (theme) => ({
  margin: 2,
});

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      sx={tabPanel_}
      {...other}
    >
      {value === index && <Box p={2}>{children}</Box>}
    </Typography>
  );
}

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

const root_ = (theme) => ({
  backgroundColor: theme.palette.background.paper,
  width: "100%",
});

const tabs_ = (theme) => ({
  "& button.MuiTab-root": {
    minWidth: "auto !important",
  },
});

export default function LayerTabs() {
  const theme = useTheme();
  const tabIndex = useSelector((state) => state.layerReducer.tabIndex);
  const dispatch = useDispatch();

  const handleChange = (event, newValue) => {
    dispatch(actionLayerTabChanged(newValue));
  };

  const handleChangeIndex = (index) => {
    dispatch(actionLayerTabChanged(index));
  };

  return (
    <Box sx={root_}>
      <AppBar position="static" color="default">
        <Tabs
          value={tabIndex}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
          aria-label="map layer tabs"
          sx={tabs_}
        >
          <Tab
            sx={tabHeading_}
            label="Graphic"
            {...a11yProps(0)}
            data-testid="layer-tab-graphic"
          />
          <Tab
            sx={tabHeading_}
            label="Label"
            {...a11yProps(1)}
            data-testid="layer-tab-label"
          />
          <Tab
            sx={tabHeading_}
            label="Color"
            {...a11yProps(2)}
            data-testid="layer-tab-color"
          />
        </Tabs>
      </AppBar>
      <SwipeableViews
        axis={theme.direction === "rtl" ? "x-reverse" : "x"}
        index={tabIndex}
        onChangeIndex={handleChangeIndex}
      >
        <TabPanel value={tabIndex} index={0} dir={theme.direction}>
          <GraphicsTabPanel layers={layerComponents} />
        </TabPanel>
        <TabPanel value={tabIndex} index={1} dir={theme.direction}>
          <LabelTabPanel layers={layerComponents} />
        </TabPanel>
        <TabPanel value={tabIndex} index={2} dir={theme.direction}>
          <ColorTabPanel layers={layerComponents} />
        </TabPanel>
      </SwipeableViews>
    </Box>
  );
}
